module.exports = __webpack_public_path__ + "static/media/avatar-child-boy.46229b05.png";